import { GetUserType } from '@orbit/api-types'

/**
 * "First L." display name used in lists and rows where space is tight.
 * Falls back to first name only, then a generic placeholder.
 */
export const getShortName = (member: GetUserType | undefined): string => {
    if (!member) return 'Unknown'
    const first = member.firstName?.trim() ?? ''
    const last = member.lastName?.trim() ?? ''
    if (first && last) return `${first} ${last[0].toUpperCase()}.`
    if (first) return first
    if (last) return last
    return 'Member'
}

export const getInitials = (member: GetUserType | undefined): string => {
    if (!member) return '?'
    const first = member.firstName?.[0] ?? ''
    const last = member.lastName?.[0] ?? ''
    return (first + last).toUpperCase() || '?'
}
